<template>
    <div class="timeline-container">
        <v-timeline
            :truncate-line="['Entregue', 'Concluído', 'Reprovado', 'Desautorizado', 'Cancelado', 'finalizada_almoxarifado', 'pagamento_finalizado', 'nao_recebido'].includes(propItem.timeline[propItem.timeline.length - 1]?.status) ? 'both' : 'start'"
            :direction="'horizontal'" :side="'start'" class="modern-timeline">
            <v-timeline-item v-for="(item, index) in propItem.timeline" :key="index" :dot-color="item.cor"
                :icon="item.icone" fill-dot class="timeline-item">
                <div v-if="item.status" class="timeline-card">
                    <div class="card-header">
                        <h3 class="card-title">{{ item.texto }}</h3>
                    </div>
                    <div v-if="item.data" class="card-content">
                        <div class="card-info">
                            <div class="info-row">
                                <span class="info-label">Data</span>
                                <span class="info-text">{{ item.data }}</span>
                            </div>
                            <div class="info-row">
                                <span class="info-label">Por</span>
                                <span class="info-text">{{ item.usuario }}</span>
                            </div>
                            <div v-if="item.responsavel_recebimento" class="info-row">
                                <span class="info-label">Para</span>
                                <span class="info-text">{{ item.responsavel_recebimento?.name }}</span>
                            </div>
                            <div v-if="item.motivo_recusa" class="info-row motivo">
                                <span class="info-label">Motivo</span>
                                <span class="info-text">{{ item.motivo_recusa }}</span>
                            </div>
                            <div v-if="item.codigo_requisicao" class="info-row">
                                <span class="info-label">Requisição</span>
                                <span class="info-text">{{ item.codigo_requisicao }}</span>
                            </div>
                            <div v-if="item.numero_pedido_compra" class="info-row">
                                <span class="info-label">Pedido compra</span>
                                <span class="info-text">{{ item.numero_pedido_compra }}</span>
                            </div>
                            <div v-if="item.numero_nf" class="info-row">
                                <span class="info-label">NF</span>
                                <span class="info-text">{{ Array.isArray(item.numero_nf) ? item.numero_nf.join(', ') : item.numero_nf }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </v-timeline-item>
        </v-timeline>
    </div>
</template>

<script>
export default {
    name: 'TimeLine',
    props: {
        propItem: { required: true }
    },
}
</script>

<style scoped>
.timeline-container {
    padding: .5rem 2rem;
    width: 100%;
    overflow-x: auto;
}

.modern-timeline {
    padding: 0;
}

.timeline-item {
    padding: 0 16px;
}

.timeline-card {
    background: var(--cor-bg);
    border: 1px solid var(--cor-separador);
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06), 0 4px 16px rgba(0, 0, 0, 0.04);
    padding: 0;
    margin: 8px 0;
    min-width: 240px;
    max-width: 320px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    overflow: hidden;
    position: relative;
}

.timeline-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, var(--cor-primaria), var(--cor-primaria-forte));
    opacity: 0;
    transition: opacity 0.3s ease;
}

/* .timeline-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1), 0 8px 24px rgba(0, 0, 0, 0.06);
    border-color: var(--cor-primaria-media);
} */

.timeline-card:hover::before {
    opacity: 1;
}

.card-header {
    padding: 16px 20px 12px;
    border-bottom: 1px solid var(--cor-separador);
    background: linear-gradient(to bottom, var(--cor-cinza), transparent);
    text-align: center;
}

.card-title {
    color: var(--cor-fonte-forte);
    font-size: 15px;
    font-weight: 600;
    margin: 0;
    line-height: 1.4;
    letter-spacing: -0.01em;
}

.card-content {
    padding: 16px 20px;
}

.card-info {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.info-row {
    display: flex;
    align-items: center;
    gap: 10px;
    color: var(--cor-fonte);
    font-size: 13px;
    line-height: 1.5;
}

.info-row.motivo {
    padding-top: 8px;
    margin-top: 4px;
    border-top: 1px solid var(--cor-separador);
    color: var(--cor-fonte-forte);
}

.info-label {
    font-size: 12px;
    font-weight: 600;
    color: var(--cor-fonte-fraca);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    min-width: 50px;
    flex-shrink: 0;
}

.info-text {
    flex: 1;
    word-break: break-word;
}

.info-text strong {
    color: var(--cor-fonte-forte);
    font-weight: 600;
}

/* Ajustes para dark mode */
.dark .timeline-card {
    background: rgba(255, 255, 255, 0.02);
    border-color: rgba(255, 255, 255, 0.1);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3), 0 4px 16px rgba(0, 0, 0, 0.2);
}

.dark .timeline-card:hover {
    border-color: var(--cor-primaria-media);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4), 0 8px 24px rgba(0, 0, 0, 0.3);
}

.dark .card-header {
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0.05), transparent);
    border-bottom-color: rgba(255, 255, 255, 0.1);
}

.dark .info-row.motivo {
    border-top-color: rgba(255, 255, 255, 0.1);
}

/* Responsividade */
@media screen and (max-width: 768px) {
    .timeline-card {
        min-width: 200px;
        max-width: 280px;
    }

    .card-header,
    .card-content {
        padding: 12px 16px;
    }

    .card-title {
        font-size: 14px;
    }

    .info-row {
        font-size: 12px;
    }
}

/* Animações de entrada */
@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.timeline-card {
    animation: fadeInUp 0.4s ease-out;
}

.timeline-item:nth-child(1) .timeline-card {
    animation-delay: 0.05s;
}

.timeline-item:nth-child(2) .timeline-card {
    animation-delay: 0.1s;
}

.timeline-item:nth-child(3) .timeline-card {
    animation-delay: 0.15s;
}

.timeline-item:nth-child(4) .timeline-card {
    animation-delay: 0.2s;
}

.timeline-item:nth-child(n+5) .timeline-card {
    animation-delay: 0.25s;
}
</style>